import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import './admin.css';

const Admin = () => {
    const [movies, setMovies] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        db.collection("movies").get().then((querySnapshot) => {
            const movieData = [];
            querySnapshot.forEach((doc) => {
                movieData.push({ id: doc.id, ...doc.data() });
            });
            setMovies(movieData);
        })
            .catch((error) => {
                console.error("Error fetching movies:", error.message);
            });
    };

    return (
        <div>
            <center>
                <h2>Movie Details</h2>
            </center>

            {movies.map((movie) => (
                <MovieFrame
                    key={movie.id}
                    title={movie.title}
                    id={movie.id}
                    genres={movie.genres}
                />
            ))}
        </div>
    );
}

const MovieFrame = ({ title, id, genres }) => {
    console.log(title + " " + id + " " + genres);
    return (
        <center>
            <div className="div">
                <p>Title: {title}</p>
                <p>ID: {id}</p>
                <p>Genres: {genres}</p>
            </div>
        </center>
    );
}

export default Admin;
